import styled from 'styled-components';
import { Typography } from '../global/theme';
import { HideScrollbar } from '../global/commonStyle';

export const AppMain = styled.div`
  .display-template {
    color: var(--brand-primary) !important;
    padding: var(--space-0) !important;
    text-decoration: none !important;
    &:hover {
      background-color: transparent !important;
      text-decoration: none !important;
    }
  }

  .EmojiPickerReact:not(.epr-search-active) .epr-category-nav > button.epr-cat-btn:hover {
    color: var(--brand-primary) !important;
  }

  .highcharts-background {
    fill: var(--background-primary) !important;
  }

  .EmojiPickerReact .epr-search-container input.epr-search {
    padding: var(--space-4) var(--space-8) !important;
    background-color: var(--background-primary) !important;
    border-radius: var(--border-radius-6) !important;
    border: 0.5px solid var(--border-primary) !important;
    color: var(--text-primary) !important;
    ${Typography.body_sm_medium}
    height: 25px !important;
  }

  .EmojiPickerReact .epr-search-container input.epr-search::placeholder {
    color: var(--background-muted) !important;
  }

  .EmojiPickerReact .epr-search-container input.epr-search:focus {
    border: 1px solid var(--brand-primary) !important;
    background: var(--background-primary) !important;
  }

  aside.EmojiPickerReact.epr-main {
    border-radius: var(--border-radius-12) !important;
    border: 0.5px solid var(--border-primary) !important;
    box-shadow: var(--shadow-dropdown) !important;
  }
`;

export const Group = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--background-secondary);
  margin: auto;
  height: 100vh;
  ${HideScrollbar}
`;
